
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menu/[[...pathParams]]",
      function () {
        return require("private-next-pages/menu/[[...pathParams]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menu/[[...pathParams]]"])
      });
    }
  